import { useSyncExternalStore as n } from "react";
const t = () => () => {
}, c = (e) => n(
  t,
  () => "client",
  () => "server"
) === "client" ? e.children : e.fallback;
export {
  c as C
};
//# sourceMappingURL=ClientOnly-E7hGysn1.js.map
